<!-- 稿件详情页 -->
<!-- 链接示例：http://localhost:8080/#/detail?channel=policy&id=2 -->
<template>
  <div>
    <div
      class="h-[478px] w-full"
      :style="`background: url(${$getImageSrc('detail-bg.jpg')}) center / cover no-repeat ;`"
    ></div>
    <div class="container-1600 pt-[31px]">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="!text-[16px]">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="item in breadcrumbItem" :key="item">{{ item }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <h1 class="mt-[91px] text-center text-[32px] text-[#1F1F1F]">
          {{ detailData.title }}
        </h1>
        <div class="mt-[50px] flex justify-between border-b border-[#cecbcb] pb-[15px]">
          <div class="text-[#636363]">
            <!-- <span class="mr-[15px]">来源：天府通</span> -->
            <span>日期：{{ detailData.create_time }}</span>
          </div>
          <div class="flex justify-center text-[20px] text-[#86888a]">
            <div class="group relative">
              <Icon icon="ant-design:wechat-outlined" class="mr-[16px] cursor-pointer" />
              <VueQrcode
                :value="pageHref ? pageHref : '123'"
                :options="{ margin: 2, width: 150 }"
                class="absolute left-[50%] mt-[5px] hidden -translate-x-[50%] shadow group-hover:block"
              ></VueQrcode>
            </div>
            <a :href="shareLink(this.pageHref, this.detailData.title).qq" target="_blank">
              <Icon icon="ant-design:qq-outlined" class="mr-[16px] cursor-pointer" />
            </a>
            <a :href="shareLink(this.pageHref, this.detailData.title).weibo" target="_blank">
              <Icon icon="ant-design:weibo-outlined" class="mr-[16px] cursor-pointer" />
            </a>
          </div>
        </div>
        <div v-html="detailData.detail" class="mb-[50px] mt-[20px]"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { shareLink, formatDate } from '@/utils/tool';
import { Icon } from '@iconify/vue2';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { talentPolicyDetail, contactDetail } from '@/api/article';

export default {
  name: 'DetailView',
  components: {
    Icon,
    VueQrcode,
  },
  data() {
    return {
      breadcrumbItem: [],
      detailData: {
        talent_policy_id: '',
        title: '',
        description: '',
        detail: '',
        keyword: '',
        jumpurl: '',
        sortid: '',
        status: '',
        create_time: '',
        update_time: '',
      },
      pageHref: window.location.href,
    };
  },
  methods: {
    shareLink,
    getData() {
      switch (this.$route.query.channel) {
        // 人才政策
        case 'policy':
          this.breadcrumbItem = ['人才服务', '人才政策'];
          talentPolicyDetail({ talent_policy_id: this.$route.query.id })
            .then((res) => {
              res.data.create_time = formatDate(res.data.create_time, 'YYYY-MM-DD HH:mm:ss');
              this.detailData = res.data;
            })
            .catch((err) => {
              console.log(err);
            });
          break;

        // 联系我们
        case 'contact':
          this.breadcrumbItem = ['联系我们'];
          contactDetail({ contact_id: this.$route.query.id })
            .then((res) => {
              res.data.create_time = formatDate(res.data.create_time, 'YYYY-MM-DD HH:mm:ss');
              this.detailData = res.data;
            })
            .catch((err) => {
              console.log(err);
            });
          break;

        default:
          this.$message.error('栏目参数错误，三秒后跳转到首页');
          setTimeout(() => {
            this.$router.push('/');
          }, 3000);
          break;
      }
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    $route() {
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped></style>
